<template>
  <div
    :class="[
      'placeholder-rect',
      { '--round': round, '--full-width': fullWidth }
    ]"
    :style="placeholderStyle"
  ></div>
</template>

<script>
export default {
  props: {
    width: { type: [String, Number], default: "100%" },
    height: { type: [String, Number], default: "56px" },
    round: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false }
  },

  computed: {
    placeholderStyle() {
      return {
        height: this.height,
        width: this.width
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.placeholder-rect {
  background: $color-ui--grey-20;
  border-radius: var(--border-radius);
  display: block;
  margin: $size--4;
  animation: load-pulse 1.2s ease infinite;

  &.--round {
    border-radius: 1000px;
  }

  &:not(.--full-width) {
    max-width: calc(100% - #{$size--4 * 2});
  }
}
</style>
